<template>
  <table class="o-schedule__content-table c-table w-100">
    <thead>
      <tr>
        <th>
          <div>Date</div>
        </th>
        <th>
          <div>
            <span class="visible-mob-only">Departure</span>
            <span class="visible-tab-des">Departure time</span>
          </div>
        </th>
        <th>
          <div>
            <span class="visible-mob-only">Arrival</span>
            <span class="visible-tab-des">Arrival time</span>
          </div>
        </th>
        <th>
          <div>Itinerary</div>
        </th>
        <th>
          <div>Price <span class="fw-r">(per 1 adult)</span></div>
        </th>
      </tr>
    </thead>

    <tbody v-if="trips.length > 0">
      <tr v-for="trip in trips" v-bind:key="trip.id">
        <td>{{ formatDate(trip.departure, "ddd DD/MM/YYYY") }}</td>
        <td>
          {{ formatDate(getDeparture(trip, origin), "HH:mm") }}
        </td>
        <td>
          {{
            formatDate(getArrival(trip, destination), "HH:mm")
          }}
        </td>
        <td>
          <div class="o-itinerary-pop" v-click-outside="() => hideItinerary(trip.id)">
            <button class="c-link is-rev" type="button" @click="toggleItinerary(trip.id)">
              Show itinerary
            </button>

            <div class="o-itinerary-pop__popup is-rounded text-center" :class="{
              'is-active': trip.id == showItineraryId
              }">
              <strong class="c-ttl--md d-block pb-1 mb-3 cl-sec-l">
                Itinerary and stops
              </strong>

              <table class="o-itinerary-pop__table c-table w-100">
                <thead>
                  <tr>
                    <th>
                      <div>Port</div>
                    </th>
                    <th>
                      <div>Arrival</div>
                    </th>
                    <th>
                      <div>Departure</div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(port, index) in getItinerary(trip)" v-bind:key="index">
                    <td>
                      <div>{{ port.name }}</div>
                    </td>
                    <td>
                      <div>{{ port.arrival ? port.arrival : '&mdash;' }}</div>
                    </td>
                    <td>
                      <div>{{ port.departure ? port.departure : '&mdash;' }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </td>
        <td>
          <span class="cl-prim fw-r">from <strong>55,00 €</strong></span>
        </td>
      </tr>
    </tbody>

    <tbody v-else>
      <tr>
        <td colspan="5" class="text-center">No trips found</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    trips: Array,
    origin: Number,
    destination: Number,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      showItineraryId: null,
    }
  },
  computed: {
    ...mapState([
      'ports'
    ]),
    ...mapGetters([
      'getPortById'
    ])
  },
  methods: {
    toggleItinerary(tripId) {
      this.showItineraryId = (tripId == this.showItineraryId) ? null : tripId
    },
    hideItinerary(tripId) {
      if (this.showItineraryId && tripId == this.showItineraryId) {
        this.showItineraryId = null
      }
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    getDeparture(trip, port) {
      return trip.itinerary.find((leg) => leg.origin_id == port).departure;
    },
    getArrival(trip, port) {
      return trip.itinerary.find((leg) => leg.destination_id == port).arrival;
    },
    getItinerary(trip) {
      let itinerary = []
      for (let i = 0; i <= trip.itinerary.length; i ++) {
        itinerary.push({
          name: this.getPortById(i ? trip.itinerary[i - 1].destination_id : trip.itinerary[i].origin_id).name,
          arrival: i ? this.formatDate(trip.itinerary[i - 1].arrival, 'HH:mm') : null,
          departure: i == trip.itinerary.length ? null : this.formatDate(trip.itinerary[i].departure, 'HH:mm')
        })
      }
      return itinerary
    },
  }
}
</script>